import { AlertIcon } from '#assets/ReactSvg.ts';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import { Spacer } from '#components/patterns/spacer/Spacer.tsx';
import styles from './DeleteTOTPError.module.css';

type Props = {
  onClose: () => void;
};

/**
 * {@link DeleteTOTPError} is a modal that warns the user that they can't delete the last TOTP authenticator.
 */
export function DeleteTOTPError({ onClose }: Props) {
  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalHeader>
        <div className={styles.DeleteTOTPError_title}>
          <AlertIcon className="mr-4" />
          <span className="truncate mw-0">Cannot delete authenticator</span>
        </div>
      </ModalHeader>
      <ModalBody>
        <p className="p">Deleting your last authenticator would prevent you from logging in.</p>
        <p className="p">Add another authenticator before deleting this one.</p>
      </ModalBody>
      <ModalFooter>
        <Spacer>
          <Button onClick={onClose}>Close</Button>
        </Spacer>
      </ModalFooter>
    </Modal>
  );
}
